/** The per-dispensary localStorage key prefix the remote writes and the host's kiosk lock screen clears. */
export const CONCIERGE_CONVERSATION_ID_KEY_PREFIX = 'concierge-conversation-id:';
